import { css, cx } from "@styled-system/css";
import { Box } from "@styled-system/jsx";

export function LongTextBox({
  text,
  children,
  styles
}: {
  text?: string | undefined;
  children: React.ReactNode | undefined;
  styles: any;
  [key: string]: any;
}) {
  return (
    <Box
      className={cx(
        css({
          "& p": {
            color: "altMediumEmphasis",
            mb: "2rem"
          },
          "& h2": {
            mb: "1rem"
          },
          "& h3": {
            mt: " 2.5rem",
            mb: "1rem",
            color: "highEmphasis"
          },
          "& h3:first-of-type": {
            mt: "0rem"
          },
          "& h4": {
            mt: " 2rem",
            mb: "0.5rem",
            color: "highEmphasis"
          },
          "& h5": {
            color: "highEmphasis",
            mb: "0.5rem"
          },
          "& img": {
            width: "100%",
            maxHeight: "32rem",
            height: "auto",
            mb: "2.5rem",
            mt: "1rem",
            borderRadius: "1rem",
            display: "flex",
            mx: "auto"
          },
          "& li": {
            color: "mediumEmphasis"
          },
          "& strong": {
            py: "1rem"
          },
          "& a": {
            color: "primary"
          },
          "& hr": {
            borderTop: "0.06rem solid lowEmphasis"
          },
          "& iframe": {
            maxWidth: "100%"
          }
        }),
        styles
      )}
      dangerouslySetInnerHTML={text ? { __html: text } : undefined}
    >
      {children}
    </Box>
  );
}
